import * as React from "react";
import type { SVGProps } from "react";
const SvgInsightIntoActionStacked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M6.527 47.822c0-.47.381-.852.851-.852H56.87a.852.852 0 1 1 0 1.704H7.378a.852.852 0 0 1-.851-.852Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M27.316 47.822c0-.47.382-.852.852-.852h2.063a.852.852 0 1 1 0 1.704h-2.063a.852.852 0 0 1-.852-.852ZM47.55 47.822c0-.47.382-.852.852-.852h2.064a.852.852 0 1 1 0 1.704h-2.064a.852.852 0 0 1-.851-.852ZM11.014 27.53V46.81l.002.004a.141.141 0 0 0 .036.041c.047.04.139.085.268.085h5.363c.13 0 .221-.044.269-.085a.143.143 0 0 0 .036-.041l.001-.004V27.536l-.001-.003a.143.143 0 0 0-.036-.042.419.419 0 0 0-.269-.085H11.22a.373.373 0 0 0-.167.076.139.139 0 0 0-.036.041l-.002.004v.001Zm1.158-1.826v-.01h-.852c-.976 0-2.01.694-2.01 1.835v19.28c0 1.142 1.034 1.836 2.01 1.836h5.363c.977 0 2.01-.694 2.01-1.835V27.539c0-1.14-1.033-1.835-2.01-1.835h-4.511Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M22.459 14.681c-.757.405-1.158 1.328-1.158 2.142v29.461c0 1.079.705 2.35 2.01 2.35h5.362c1.306 0 2.01-1.271 2.01-2.35v-29.47c0-1.08-.704-2.351-2.01-2.351H22.46v.218Zm1.703 1.485v.01h-.851c-.005 0-.063 0-.146.108a.894.894 0 0 0-.161.54v29.46c0 .242.076.43.161.54.083.108.141.107.146.107h5.362c.005 0 .063 0 .146-.107a.895.895 0 0 0 .16-.54v-29.47a.896.896 0 0 0-.16-.54c-.083-.108-.141-.108-.146-.108h-4.51ZM47.293 12.809a.307.307 0 0 0-.307.306v33.52c0 .17.138.306.307.306h5.373c.169 0 .306-.137.306-.306v-33.52a.307.307 0 0 0-.306-.306h-5.373Zm-2.01.306c0-1.11.9-2.01 2.01-2.01h5.373c1.11 0 2.01.9 2.01 2.01v33.52c0 1.11-.9 2.01-2.01 2.01h-5.373c-1.11 0-2.01-.9-2.01-2.01v-33.52ZM34.45 21.72a2.058 2.058 0 0 0-.458.24c-.372.262-.7.7-.7 1.277v23.719c0 .574.331 1.012.697 1.271.37.262.835.398 1.313.398h5.363c.472 0 .938-.131 1.31-.392.371-.262.7-.701.7-1.277V23.227c0-.574-.332-1.012-.698-1.271a2.277 2.277 0 0 0-1.312-.398H34.45v.161Zm1.703 1.541v.01h-.851a.643.643 0 0 0-.307.068V46.85c.057.033.162.07.307.07h5.363c.146 0 .25-.036.306-.067V23.332a.623.623 0 0 0-.306-.07h-4.512Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M14.085 22.225a3.153 3.153 0 1 0 0-6.307 3.153 3.153 0 0 0 0 6.307Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M14.085 16.77a2.302 2.302 0 1 0 0 4.603 2.302 2.302 0 0 0 0-4.603ZM10.08 19.07a4.005 4.005 0 1 1 8.01 0 4.005 4.005 0 0 1-8.01 0ZM26.163 5.626a2.302 2.302 0 1 0 0 4.603 2.302 2.302 0 0 0 0-4.603Zm-4.005 2.301a4.005 4.005 0 1 1 8.01 0 4.005 4.005 0 0 1-8.01 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M37.949 17.728a3.153 3.153 0 1 0 0-6.307 3.153 3.153 0 0 0 0 6.307Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M37.949 12.273a2.302 2.302 0 1 0 0 4.604 2.302 2.302 0 0 0 0-4.604Zm-4.005 2.302a4.005 4.005 0 1 1 8.01 0 4.005 4.005 0 0 1-8.01 0ZM49.91 1.703a2.302 2.302 0 1 0 0 4.604 2.302 2.302 0 0 0 0-4.604Zm-4.004 2.302a4.005 4.005 0 1 1 8.01 0 4.005 4.005 0 0 1-8.01 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M13.919 53.03v1.508c0 .438-.36.798-.798.798H7.924a.802.802 0 0 0-.799.798v3.445c0 .438.36.798.799.798h5.207c.438 0 .798.36.798.798v1.178c0 .681.798 1.041 1.314.604l5.46-4.662a.795.795 0 0 0 0-1.207l-5.46-4.662c-.516-.438-1.314-.078-1.314.603h-.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M13.086 52.851c.131-1.303 1.695-1.934 2.708-1.074l.002.001 5.458 4.66c.777.658.761 1.845.007 2.5l-.005.004-5.46 4.662-.002.002c-1.058.898-2.717.169-2.717-1.253V61.23H7.924c-.909 0-1.65-.741-1.65-1.65v-3.445c0-.908.741-1.65 1.65-1.65h5.143V53.03c0-.06.007-.12.019-.178Zm1.685.307v1.38c0 .908-.742 1.65-1.65 1.65H7.977v3.338h5.154c.908 0 1.65.741 1.65 1.65v1.055l5.317-4.54-5.325-4.547-.002.014ZM31.024 53.03c0-1.422 1.659-2.152 2.717-1.253l.001.001 5.459 4.66c.777.658.76 1.845.007 2.5l-.005.004-5.46 4.662-.002.002c-1.058.898-2.717.169-2.717-1.253V61.23H25.87c-.908 0-1.65-.741-1.65-1.65v-3.445c0-.908.742-1.65 1.65-1.65h5.154V53.03Zm1.703.12 5.318 4.541-5.318 4.54v-1.056c0-.908-.741-1.65-1.65-1.65h-5.153v-3.337h5.153c.909 0 1.65-.742 1.65-1.65V53.15Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M49.823 53.03v1.508c0 .438-.36.798-.798.798h-5.207a.802.802 0 0 0-.798.798v3.445c0 .438.36.798.798.798h5.207c.438 0 .798.36.798.798v1.178c0 .681.798 1.041 1.314.604l5.46-4.662a.795.795 0 0 0 0-1.207l-5.46-4.662c-.516-.438-1.314-.078-1.314.603Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M48.972 53.03c0-1.422 1.658-2.152 2.716-1.253l.002.001 5.459 4.66c.777.658.76 1.845.007 2.5l-.006.004-5.46 4.662-.002.002c-1.058.898-2.716.169-2.716-1.253V61.23h-5.154c-.908 0-1.65-.741-1.65-1.65v-3.445c0-.908.742-1.65 1.65-1.65h5.154V53.03Zm1.703.12 5.318 4.541-5.318 4.54v-1.056c0-.908-.741-1.65-1.65-1.65h-5.153v-3.337h5.153c.909 0 1.65-.742 1.65-1.65V53.15Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInsightIntoActionStacked;
